import { type AvsDateRangeIds } from '@ui';
import type { GridsterItem } from 'angular-gridster2';

export interface BaseWidgetConfig<Type> {
  locationId: string;
  name: string;
  type: Type;
}

export interface BaseWidgetDeviceConfig<Type> extends BaseWidgetConfig<Type> {
  datapointName: string;
  dateRange?: AvsDateRangeIds;
  deviceId: string;
  floorId: string;
  roomId: string;
}

export interface BaseWidgetLocationConfig<Type> extends BaseWidgetConfig<Type> {
  floorId?: string;
  roomId?: string;
}

export type WidgetBuildingPlan = BaseWidgetConfig<'buildingPlan'>;
export type WidgetDataPoint = Omit<BaseWidgetDeviceConfig<'dataPoint'>, 'dateRange'>;
export type WidgetDeviceChart = BaseWidgetDeviceConfig<'deviceChart'>;
export interface WidgetDeviceStats extends BaseWidgetDeviceConfig<'deviceStats'> {
  dataType: StatsSupportedTypes,
  displayOptions: { [key: string]: boolean; };
}
export type WidgetDevices = BaseWidgetLocationConfig<'devices'>;
export interface WidgetGauge extends Omit<BaseWidgetDeviceConfig<'gauge'>, 'dateRange'> {
  criticalMax: number;
  criticalMin: number;
  normalMax: number;
  normalMin: number;
  warningMax: number;
  warningMin: number;
}
export type WidgetMap = BaseWidgetConfig<'map'>;
export interface WidgetRoomState extends BaseWidgetConfig<'roomState'> {
  datapoints: {
    co2: string;
    humidity: string;
    people: string;
    pm10: string;
    pm25: string;
    temperature: string;
    tvoc: string;
  };
  devices: {
    airMonitor: string;
    camera: string;
  };
  floorId: string;
  roomId: string;
}
export type WidgetSpaceDetails = BaseWidgetLocationConfig<'spaceDetails'>;

export interface WidgetConnectedDevices extends BaseWidgetConfig<'connectedDevices'> {
  deviceIds: string[];
}

export type WidgetConfig
  = WidgetBuildingPlan
  | WidgetConnectedDevices
  | WidgetDataPoint
  | WidgetDeviceChart
  | WidgetDevices
  | WidgetGauge
  | WidgetDeviceStats
  | WidgetMap
  | WidgetRoomState
  | WidgetSpaceDetails;

export interface Widget extends GridsterItem {
  cols: number;
  config: WidgetConfig;
  id: number;
  rows: number;
  x: number;
  y: number;
}


export enum StatsSupportedTypes {
  THERMOSTAT = 'temp',
  POWER = 'wattage',
}
